export default {
    placeholderEmployeeFirstName: 'Jessica',
};
